import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  fr: {
    translation: {
      // Navigation
      nav_bookings: "Mes réservations",
      nav_book: "Réserver",
      nav_login: "Connexion",
      nav_signup: "S'inscrire",
      nav_logout: "Déconnexion",

      // Hero
      hero_badge: "100% Électrique",
      hero_title_1: "Voyagez en",
      hero_title_2: "silence",
      hero_title_3: "élégance",
      hero_title_4: "et",
      hero_title_5: "confort",
      hero_subtitle: "Service VTC premium avec Tesla Model Y. Réservez votre chauffeur privé et profitez d'une expérience de transport haut de gamme, 100% écologique.",
      hero_cta: "Réserver maintenant",
      hero_estimate: "Simuler un prix",
      hero_pricing: "Voir les tarifs",
      per_km: "par kilomètre",
      per_min: "par minute",
      co2_emitted: "CO₂ émis",

      // Promo
      promo_code_label: "Code promo",
      promo_first_booking: "-10% sur votre première réservation",
      promo_online_payment: "paiement en ligne",

      // Features
      features_title: "Pourquoi choisir",
      feature_electric: "100% Électrique",
      feature_electric_desc: "Voyagez en Tesla Model Y, le SUV électrique premium. Zéro émission, silence total.",
      feature_drivers: "Chauffeurs Professionnels",
      feature_drivers_desc: "Nos chauffeurs sont formés pour offrir un service irréprochable et discret.",
      feature_comfort: "Confort Premium",
      feature_comfort_desc: "Wi-Fi à bord, chargeurs, eau fraîche. Tout pour votre confort.",
      feature_competitive: "Tarifs compétitifs",
      feature_competitive_desc: "Meilleurs prix VTC Nice et Côte d'Azur",
      feature_recent_vehicle: "Véhicule récent",
      feature_recent_vehicle_desc: "Tesla Model Y impeccable",
      feature_water: "Eau & chargeurs",
      feature_water_desc: "Confort premium à bord",
      feature_discretion: "Discrétion",
      feature_discretion_desc: "Service professionnel",
      feature_multilingual: "Multilingue",
      feature_multilingual_desc: "FR, EN",
      feature_zero_emission: "100% Électrique",
      feature_zero_emission_desc: "0 émission CO₂",

      // Loyalty
      loyalty_title: "Programme Fidélité & Parrainage",
      loyalty_rewards: "Vos trajets vous récompensent",
      loyalty_referral: "Parrainage",
      loyalty_referral_desc: "Parrainez un ami et recevez chacun",
      loyalty_referral_amount: "10€ offerts",
      loyalty_online_discount: "-10% en ligne",
      loyalty_online_discount_desc: "Réduction automatique en ligne",
      loyalty_5_rides: "5 courses = -20%",
      loyalty_5_rides_desc: "20% de réduction automatique",
      loyalty_10th_free: "10ème OFFERTE",
      loyalty_10th_desc: "Course gratuite (max 25€)",
      loyalty_gift: "Cadeau fidélité",
      loyalty_automatic: "Automatique",

      // Airport
      airport_title: "Transfert aéroport Nice",
      airport_subtitle: "Navette Aéroport Nice Côte d'Azur",
      airport_fixed_rates: "Tarifs fixes",
      airport_one_way: "Aller simple",
      airport_round_trip: "Aller-Retour",
      airport_welcome_sign: "Accueil pancarte nominative",
      airport_flight_tracking: "Suivi de vol en temps réel",
      airport_free_wait: "30 min attente gratuite",
      airport_luggage: "Bagages inclus",
      airport_no_surprise: "Aucune surprise tarifaire",
      airport_same_day: "Prix valable pour un aller-retour le même jour",
      airport_book: "Réserver",
      airport_st_tropez_note: "Le tarif aller-retour Saint-Tropez à 300€ est valable uniquement pour un trajet aller-retour effectué la même journée.",
      airport_privilege_note_label: "¹ Prix fixes toute l'année pour les clients privilèges.",
      airport_privilege_note_text: "Pour les autres clients, ces prix peuvent varier selon la saison et les événements spéciaux (Festival de Cannes, Grand Prix de Monaco, Noël, Nouvel An, etc.).",
      privilege_badge: "Programme Privilège",
      privilege_subbadge: "Avantages exclusifs",
      privilege_title: "Devenez Client Privilège YOUMI GREEN VTC",
      privilege_body: "Les clients inscrits ayant effectué un minimum de 10 courses sur les 6 derniers mois accèdent à des prix fixes et bas à vie, ainsi qu'à tous les avantages exclusifs fournis par la société YOUMI GREEN VTC.",
      privilege_eligibility: "Éligibilité : 10 courses minimum sur les 6 derniers mois. Statut accordé automatiquement après vérification.",
      privilege_cta: "Créer un compte",
      privilege_terms_link: "Voir les conditions",
      price_guarantee_title: "Prix fixe garanti — Aucune surprise tarifaire",
      price_guarantee_text: "Votre prix est confirmé à la réservation et ne changera jamais, même en cas de retard de vol, embouteillages ou conditions météo.",
      price_guarantee_full: "Votre prix est confirmé dès la réservation et ne changera jamais, même en cas de retard de vol, embouteillages ou conditions météo. Contrairement aux taxis et Uber, nous ne pratiquons aucun tarif dynamique.",
      fixed_price_badge: "Prix fixe garanti \u2713",
      airport_seo: "VTC Nice aéroport - Transfert Nice Cannes - Navette aéroport Nice Monaco - Chauffeur privé Saint-Tropez - VTC Côte d'Azur premium",

      // Why choose us
      why_title: "Pourquoi choisir YOUMI GREEN VTC Nice ?",
      why_subtitle: "Votre chauffeur privé à Nice pour des trajets premium, écologiques et professionnels.",

      // Business
      business_badge: "Clients Professionnels",
      business_title: "VTC entreprise - Solutions sur mesure",
      business_desc: "Service de chauffeur privé pour entreprises à Nice et sur la Côte d'Azur. Facturation mensuelle possible pour vos déplacements professionnels.",
      business_congress: "Congrès & Séminaires",
      business_hotels: "Partenariats Hôtels",
      business_trips: "Déplacements Entreprises",
      business_billing: "Facturation mensuelle",
      business_quote: "Demander un devis entreprise",
      business_advantages: "Avantages Entreprises",
      business_adv_1: "Compte entreprise dédié",
      business_adv_2: "Facturation groupée mensuelle",
      business_adv_3: "Tarifs préférentiels volume",
      business_adv_4: "Reporting détaillé des trajets",
      business_adv_5: "Chauffeur attitré possible",
      business_adv_6: "Disponibilité 7j/7",

      // Pricing
      pricing_title: "Tarifs VTC Nice au kilomètre",
      pricing_subtitle: "Courses urbaines & régionales • Berline Standard (4 passagers)",
      pricing_pickup: "Prise en charge",
      pricing_day: "Jour (7h-19h)",
      pricing_night: "Nuit (19h-7h)",
      pricing_per_km: "par km",
      pricing_wait: "Attente",
      pricing_min_fare: "Tarif minimum",
      pricing_min_booking: "Réservation minimum",
      pricing_advance: "1h à l'avance",
      pricing_book: "Réserver VTC Nice",
      pricing_simulate: "Simuler",

      // Service area
      service_area_badge: "Zone de service VTC",
      service_area_title: "Chauffeur privé Côte d'Azur & Var",
      service_area_desc: "VTC Nice, chauffeur privé Cannes, VTC Monaco, transfert Saint-Tropez. Nous intervenons sur toute la Côte d'Azur et le Var.",
      service_area_quote: "Demande de devis",
      service_area_services: "Nos services VTC",
      service_1: "Transfert aéroport Nice Côte d'Azur",
      service_2: "Navette Nice Cannes Monaco",
      service_3: "Chauffeur Saint-Tropez",
      service_4: "Événements & mariages",
      service_5: "Mise à disposition horaire",
      service_6: "VTC longue distance",

      // Reviews
      reviews_title: "Avis Clients",
      reviews_subtitle: "Découvrez ce que nos clients pensent de notre service",
      reviews_what_say: "Ce que nos clients disent de nous",
      reviews_satisfaction: "La satisfaction de nos clients est notre priorité. Découvrez leurs témoignages.",
      reviews_see_google: "Voir tous nos avis sur Google",
      reviews_leave: "Laissez-nous un avis sur Google",
      reviews_your_opinion: "Votre avis compte ! Partagez votre expérience avec YOUMI GREEN VTC",

      // Accessibility
      accessibility_badge: "Accessibilité",
      accessibility_title: "Malentendant ? Réservez par écrit",
      accessibility_desc: "Nous proposons un service de réservation entièrement par écrit pour les personnes malentendantes. Aucun appel téléphonique nécessaire.",
      accessibility_book: "Réserver en ligne (sans appel)",
      accessibility_whatsapp: "WhatsApp (écrit uniquement)",

      // Footer
      footer_copyright: "Service de transport privé premium 100% électrique.",
      footer_seo: "YOUMI GREEN VTC - Votre service de VTC Nice premium et écologique.",

      // Auth
      auth_welcome: "Bon retour !",
      auth_create: "Créer un compte",
      auth_login_subtitle: "Connectez-vous pour réserver votre course",
      auth_register_subtitle: "Inscrivez-vous pour profiter de nos services",
      auth_firstname: "Prénom",
      auth_lastname: "Nom",
      auth_email: "Email",
      auth_phone: "Téléphone",
      auth_password: "Mot de passe",
      auth_confirm_password: "Confirmer le mot de passe",
      auth_login_btn: "Se connecter",
      auth_register_btn: "S'inscrire",
      auth_no_account: "Pas encore de compte ?",
      auth_has_account: "Déjà un compte ?",
      auth_forgot_password: "Mot de passe oublié ?",
      auth_forgot_title: "Mot de passe oublié",
      auth_forgot_desc: "Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
      auth_send_link: "Envoyer le lien",
      auth_sending: "Envoi...",
      auth_cancel: "Annuler",
      auth_min_chars: "Minimum 8 caractères",
      auth_passwords_mismatch: "Les mots de passe ne correspondent pas",
      auth_loading: "Chargement...",
      auth_verify_email: "Vérifiez votre email",
      auth_verify_email_sent: "Un email de confirmation a été envoyé à",
      auth_verify_email_click: "Cliquez sur le lien dans l'email pour activer votre compte et pouvoir vous connecter.",
      auth_verified_login: "J'ai vérifié, me connecter",
      auth_resend: "Renvoyer l'email de vérification",
      auth_referral_code: "Code de parrainage (optionnel)",
      auth_referral_hint: "Entrez le code d'un ami et recevez 10€ de crédit chacun !",
      auth_business_account: "Compte Professionnel / Entreprise",
      auth_company_name: "Nom de l'entreprise *",
      auth_vat_number: "Numéro de TVA *",
      auth_billing_address: "Adresse de facturation",
      auth_billing_type: "Mode de facturation",
      auth_per_trip: "Par course",
      auth_monthly: "Mensuelle",
      auth_billing_note: "Les factures seront émises en HT (Hors Taxes) avec TVA 10% applicable au transport.",
      back_home: "Retour à l'accueil",

      // Booking
      booking_step_route: "Trajets",
      booking_step_datetime: "Date & Heure",
      booking_step_payment: "Paiement",
      booking_your_trips: "Vos trajets",
      booking_add_trip: "Ajouter un trajet",
      booking_trip: "Trajet",
      booking_remove: "Supprimer",
      booking_pickup: "Adresse de prise en charge",
      booking_destination: "Destination",
      booking_address_selected: "Adresse sélectionnée",
      booking_round_trip: "Aller-retour le même jour (-10% sur le total)",
      booking_date_time: "Date et heure de vos trajets",
      booking_min_advance: "Réservation minimum 1 heure à l'avance",
      booking_date: "Date",
      booking_time: "Heure",
      booking_select: "Sélectionner",
      booking_min_warning: "La réservation doit être faite au moins 1 heure à l'avance",
      booking_extra_info: "Informations complémentaires",
      booking_flight: "Numéro de vol (optionnel)",
      booking_flight_hint: "Pour les trajets depuis/vers l'aéroport, nous suivrons votre vol en temps réel",
      booking_ambiance: "Ambiance souhaitée",
      booking_quiet: "Calme",
      booking_music: "Musique",
      booking_conversation: "Conversation",
      booking_climate: "Climatisation / Chauffage",
      booking_climate_auto: "Auto",
      booking_climate_ac: "Clim",
      booking_climate_heat: "Chauffage",
      booking_special: "Demandes spéciales (optionnel)",
      booking_special_placeholder: "Siège bébé, bagages volumineux, assistance mobilité...",
      booking_payment_method: "Mode de paiement",
      booking_card: "Carte bancaire",
      booking_card_stripe: "Paiement sécurisé via Stripe",
      booking_apple_pay: "Apple Pay",
      booking_google_pay: "Google Pay",
      booking_paypal: "PayPal",
      booking_card_onboard: "Carte bancaire à bord",
      booking_pay_driver: "Paiement au chauffeur",
      booking_cash: "Espèces",
      booking_fast_secure: "Paiement rapide et sécurisé",
      booking_via_paypal: "Paiement via votre compte PayPal",
      booking_promo_code: "Code promo",
      booking_promo_placeholder: "Entrez votre code",
      booking_apply: "Appliquer",
      booking_wallet: "Ma Cagnotte",
      booking_use: "Utiliser",
      booking_wallet_deducted: "seront déduits de votre course",
      booking_back: "Retour",
      booking_continue: "Continuer",
      booking_confirm: "Confirmer la réservation",
      booking_summary: "Récapitulatif",
      booking_round_trip_discount: "Réduction aller-retour",
      booking_total_ht: "Total HT",
      booking_vat: "TVA (10%)",
      booking_wallet_used: "Cagnotte",
      booking_to_pay: "À payer",
      booking_paid_wallet: "Entièrement payé avec votre cagnotte !",
      booking_enter_addresses: "Entrez vos adresses pour voir l'estimation",
      booking_co2: "0g CO₂ émis • 100% électrique",
      booking_hello: "Bonjour",
      booking_my_bookings: "Mes réservations",

      // Dashboard
      dashboard_hello: "Bonjour",
      dashboard_subtitle: "Gérez vos réservations et consultez votre historique de courses.",
      dashboard_upcoming: "Courses à venir",
      dashboard_past: "Courses effectuées",
      dashboard_co2_saved: "CO₂ économisé",
      dashboard_no_booking: "Aucune réservation",
      dashboard_no_booking_desc: "Vous n'avez pas encore effectué de réservation.",
      dashboard_first_booking: "Réserver ma première course",
      dashboard_upcoming_tab: "À venir",
      dashboard_past_tab: "Historique",
      new_booking: "Nouvelle réservation",

      // Confirmation
      confirm_checking: "Vérification du paiement...",
      confirm_wait: "Merci de patienter quelques instants",
      confirm_success: "Réservation confirmée !",
      confirm_success_online: "Merci pour votre réservation. Un email de confirmation vous a été envoyé.",
      confirm_success_onboard: "Votre chauffeur vous contactera pour confirmer les détails.",
      confirm_cancelled: "Paiement annulé",
      confirm_cancelled_desc: "Votre paiement a été annulé. Vous pouvez réessayer ou choisir un autre mode de paiement.",
      confirm_retry: "Nouvelle réservation",
      confirm_view_bookings: "Voir mes réservations",
      confirm_details: "Détails de la course",
      confirm_departure: "Départ",
      confirm_arrival: "Arrivée",
      confirm_date: "Date",
      confirm_time: "Heure",
      confirm_paid: "Payé",
      confirm_pay_driver: "À régler au chauffeur",

      // Status
      status_confirmed: "Confirmé",
      status_pending: "En attente",
      status_cancelled: "Annulé",

      // Evaluate
      eval_title: "Comment s'est passée votre course ?",
      eval_subtitle: "Votre avis nous aide à nous améliorer",
      eval_rate: "Notez votre expérience",
      eval_5: "Excellent !",
      eval_4: "Très bien !",
      eval_3: "Bien",
      eval_2: "Peut mieux faire",
      eval_1: "Décevant",
      eval_comment: "Un commentaire ? (optionnel)",
      eval_placeholder: "Partagez votre expérience...",
      eval_submit: "Envoyer mon évaluation",
      eval_already: "Déjà évalué !",
      eval_already_desc: "Vous avez déjà noté cette course",
      eval_thanks: "Merci !",
      eval_thanks_desc: "Votre avis nous aide à améliorer notre service",
      eval_happy: "Content que notre service vous ait plu !",
      eval_google: "Laissez aussi un avis Google",
      eval_departure: "Départ",
      eval_arrival: "Arrivée",
      eval_back: "Retour à l'accueil",

      // Simulator
      simulator_title: "Simulateur de prix",
      simulator_subtitle: "Estimez le coût de votre course sans créer de compte",
      simulator_calculate: "Calculer le prix",

      // Contact
      contact_whatsapp: "Contactez-nous sur WhatsApp",

      // Quick Booking
      quick_badge: "Réservation rapide",
      quick_title: "Réservez votre course",
      quick_subtitle: "Pas besoin de compte. Remplissez le formulaire et nous vous confirmons par téléphone ou WhatsApp.",
      quick_identity: "Vos coordonnées",
      quick_optional: "optionnel",
      quick_route: "Votre trajet",
      quick_options: "Options",
      quick_passengers: "Nombre de passagers",
      quick_message: "Message (optionnel)",
      quick_message_placeholder: "Siège bébé, bagages volumineux, numéro de vol...",
      quick_submit: "Envoyer ma demande",
      flight_number_title: "Informations de vol",
      flight_number_label: "Numéro de vol",
      flight_number_hint: "Nous suivrons votre vol pour vous attendre à l'arrivée.",
      round_trip_label: "Aller-retour",
      round_trip_same_day: "Aller-retour le même jour uniquement",
      round_trip_price: "Aller-retour",
      one_way_price: "Aller simple",
      estimate_loading: "Calcul du prix en cours...",
      sim_title: "Simulateur de prix",
      sim_subtitle: "Estimez le coût de votre course sans créer de compte",
      sim_pickup: "Adresse de départ",
      sim_pickup_placeholder: "Ex: Aéroport Nice Côte d'Azur",
      sim_destination: "Destination",
      sim_dest_placeholder: "Ex: Cannes Centre",
      sim_address_selected: "Adresse sélectionnée",
      sim_calculating: "Calcul en cours...",
      sim_calculate: "Calculer le prix",
      sim_electric: "électrique",
      sim_price_ht: "Prix HT",
      sim_tva: "TVA (10%)",
      sim_total_ttc: "Prix TTC total",
      sim_hour: "Heure de prise en charge",
      sim_night_warning: "Majoration nuit +10% (21h-6h)",
      sim_base_price: "Tarif de base",
      sim_calc_km: "Calcul au kilometre",
      sim_calc_time: "Calcul au temps",
      sim_time_label: "temps",
      sim_night_surcharge: "Majoration nuit (+10%)",
      sim_rt_discount: "Reduction A/R (-15% retour)",
      sim_disclaimer_fixed: "* Prix fixes garantis pour toute course effectuee entre 6h et 21h.",
      sim_seasonal_adj: "Ajustement tarifaire",
      sim_disclaimer_night: "** Une majoration de 10% s'applique automatiquement pour toute course entre 21h et 6h.",
      sim_disclaimer_st_tropez: "*** Tarif aller-retour Saint-Tropez valable uniquement pour un aller-retour effectue le meme jour.",
      estimate_title: "Estimation de votre course",
      estimate_duration: "Durée estimée",
      estimate_price_ttc: "Prix estimé TTC",
      estimate_note: "* Prix indicatif. Le tarif final peut varier selon les conditions.",
      stops_title: "Arrêts intermédiaires",
      stop_address: "Adresse arrêt",
      stop_placeholder: "Adresse de l'arrêt...",
      stop_wait_time: "Temps d'attente",
      stop_no_wait: "Aucun",
      stop_custom: "Autre",
      stop_wait_cost: "Coût attente",
      stop_add: "Ajouter un arrêt",
      price_base_ride: "Prix trajet de base",
      price_stops_wait: "Arrêts & attentes",
      quick_success_title: "Demande envoyée !",
      quick_success_desc: "Votre demande a bien été envoyée ! Vous recevrez une confirmation sous peu par WhatsApp ou téléphone.",
      quick_create_account: "Créer un compte pour gérer mes réservations",
      quick_or_login: "Vous avez déjà un compte ?",

      // Common
      common_loading: "Chargement...",

      // Video Showcase
      video_badge: "Decouvrez notre service",
      video_title_1: "L'excellence du transport",
      video_title_2: "prive",
      video_cta: "Reserver maintenant",
      video_quote: "Demander un devis",
      video_company: "Chauffeur prive premium - Cote d'Azur",

      // Footer
      footer_legal: "Mentions legales",
      footer_cgv: "CGV",
      footer_privacy: "Confidentialite",
      footer_deletion: "Suppression des donnees",
      footer_quote: "Demander un devis",
      footer_admin: "Espace Admin",
      footer_copyright: "Chauffeur prive Cote d'Azur",
      footer_seo_line: "VTC Nice - Transfert Cannes - Navette Monaco - Chauffeur Saint-Tropez",

      // Pin / Location
      pin_mode_active: "Repere actif",
      pin_place: "Placer un repere",
      pin_indicator: "Cliquez sur la carte pour placer le repere",
      my_location: "Ma position",
      share_position_title: "Partagez votre position au chauffeur",
      share_whatsapp: "WhatsApp",
      share_sms: "SMS",

      // Data Deletion Page
      deletion_title: "Suppression des donnees",
      deletion_how: "Comment demander la suppression de vos donnees",
      deletion_rgpd: "Conformement au Reglement General sur la Protection des Donnees (RGPD), vous pouvez demander la suppression de l'ensemble de vos donnees personnelles detenues par",
      deletion_send_email: "Pour effectuer votre demande, envoyez un email a :",
      deletion_subject: "Objet :",
      deletion_subject_value: "Suppression des donnees",
      deletion_info_required: "Informations a fournir dans votre email :",
      deletion_info_name: "Votre nom complet",
      deletion_info_email: "Votre adresse email associee a votre compte",
      deletion_info_phone: "Votre numero de telephone utilise lors de vos reservations",
      deletion_info_other: "Toute information permettant de vous identifier (numero de reservation, etc.)",
      deletion_delay_title: "Delai de traitement",
      deletion_delay_text: "Votre demande sera traitee dans un delai maximum de 30 jours ouvrables a compter de la reception de votre email. Un accuse de reception vous sera envoye par email avec un identifiant de suivi de votre demande.",
      deletion_data_title: "Donnees supprimees",
      deletion_data_text: "La suppression concerne l'ensemble de vos donnees personnelles, notamment :",
      deletion_data_1: "Informations de compte (nom, prenom, email, telephone)",
      deletion_data_2: "Historique de reservations et de courses",
      deletion_data_3: "Donnees de paiement associees",
      deletion_data_4: "Preferences et parametres de votre compte",
      deletion_data_5: "Donnees de localisation liees a vos courses",
      deletion_exceptions_title: "Exceptions legales",
      deletion_exceptions_text: "Certaines donnees peuvent etre conservees au-dela de votre demande de suppression, conformement aux obligations legales en vigueur :",
      deletion_exc_1: "Factures et donnees comptables",
      deletion_exc_1_detail: "conservation obligatoire de 10 ans (Code de commerce, art. L123-22)",
      deletion_exc_2: "Donnees de transaction",
      deletion_exc_2_detail: "conservation de 5 ans a des fins fiscales",
      deletion_exc_3: "Donnees necessaires a un litige en cours",
      deletion_exc_3_detail: "conservees jusqu'a la resolution du litige",
      deletion_exc_4: "Obligations reglementaires",
      deletion_exc_4_detail: "toute donnee dont la conservation est imposee par la loi francaise ou europeenne",
      deletion_retained_note: "Les donnees conservees pour obligation legale ne seront utilisees qu'a cette fin et seront supprimees a l'expiration du delai legal applicable.",

      // Callback Page
      callback_title: "Demande de suppression recue",
      callback_text: "Votre demande de suppression de donnees a bien ete prise en compte. Elle sera traitee dans un delai maximum de",
      callback_days: "30 jours ouvrables",
      callback_request_id: "Identifiant de demande",
      callback_id_info: "Un identifiant de demande peut vous etre envoye par email pour le suivi de votre requete.",
      callback_contact_info: "Pour toute question concernant votre demande, contactez-nous a :",
      callback_back: "Retour a l'accueil",

      // Quote Request Page
      quote_title: "Demande de",
      quote_title_accent: "devis",
      quote_subtitle: "Evenement special, groupe, longue distance ? Decrivez votre besoin et recevez un devis personnalise sous 24h.",
      quote_contact_section: "Vos coordonnees",
      quote_name: "Nom complet",
      quote_phone: "Telephone",
      quote_email: "Email",
      quote_event_section: "Votre evenement",
      quote_event_type: "Type d'evenement",
      quote_select: "Selectionnez...",
      quote_event_wedding: "Mariage",
      quote_event_seminar: "Seminaire / Entreprise",
      quote_event_party: "Soiree / Evenement prive",
      quote_event_tourism: "Circuit touristique",
      quote_event_airport: "Transfert aeroport (groupe)",
      quote_event_long: "Longue distance",
      quote_event_other: "Autre",
      quote_date: "Date souhaitee",
      quote_time: "Heure",
      quote_passengers: "Nombre de passagers",
      quote_duration: "Duree estimee",
      quote_duration_placeholder: "Ex: 3 heures, 1 journee",
      quote_route_section: "Itineraire",
      quote_pickup: "Lieu de depart",
      quote_pickup_placeholder: "Adresse de prise en charge",
      quote_destination: "Destination",
      quote_dest_placeholder: "Adresse de destination",
      quote_details_section: "Details supplementaires",
      quote_details_placeholder: "Decrivez vos besoins specifiques : nombre de vehicules, bagages, arrets multiples, besoins particuliers...",
      quote_submit: "Envoyer ma demande de devis",
      quote_response_note: "Reponse garantie sous 24h. Vous pouvez aussi nous contacter directement au",
      quote_success_title: "Demande envoyee !",
      quote_success_text: "Nous vous recontacterons dans les plus brefs delais avec votre devis personnalise.",

      // Reviews (hardcoded)
      review_1_name: "Marie L.",
      review_1_text: "Service impeccable ! Chauffeur ponctuel et tres professionnel. La Tesla est un vrai plus pour le confort. Je recommande vivement.",
      review_2_name: "Pierre D.",
      review_2_text: "Transfert aeroport Nice parfait. Le chauffeur m'attendait avec une pancarte, voiture propre et climatisee. Prix tres correct.",
      review_3_name: "Sophie M.",
      review_3_text: "Excellent service pour mon trajet Nice-Monaco. Chauffeur discret et vehicule electrique silencieux. Top !",
      review_cta_text: "Service impeccable ! Chauffeur ponctuel et tres professionnel. La Tesla est un vrai plus pour le confort et l'ecologie. Je recommande vivement !",
      review_cta_text_2: "Excellent service pour mon transfert aeroport. Communication facile, voiture propre et confortable. Rapport qualite-prix parfait.",

      // SEO footer text
      seo_text: "<strong>YOUMI GREEN VTC</strong> - Votre service de <strong>VTC Nice</strong> premium et ecologique. <strong>Chauffeur prive Nice</strong> pour tous vos deplacements : <strong>transfert Nice Cannes</strong>, <strong>navette aeroport Nice</strong>, <strong>VTC Monaco</strong>, <strong>chauffeur Saint-Tropez</strong>. Service de transport prive sur la <strong>Cote d'Azur</strong> et le <strong>Var</strong> en Tesla Model Y 100% electrique. Reservation 1h a l'avance, tarifs competitifs, service multilingue.",
    }
  },
  en: {
    translation: {
      // Navigation
      nav_bookings: "My bookings",
      nav_book: "Book now",
      nav_login: "Login",
      nav_signup: "Sign up",
      nav_logout: "Logout",

      // Hero
      hero_badge: "100% Electric",
      hero_title_1: "Travel in",
      hero_title_2: "silence",
      hero_title_3: "elegance",
      hero_title_4: "and",
      hero_title_5: "comfort",
      hero_subtitle: "Premium VTC service with Tesla Model Y. Book your private driver and enjoy a high-end, 100% eco-friendly transport experience.",
      hero_cta: "Book now",
      hero_estimate: "Price estimate",
      hero_pricing: "See pricing",
      per_km: "per kilometer",
      per_min: "per minute",
      co2_emitted: "CO₂ emitted",

      // Promo
      promo_code_label: "Promo code",
      promo_first_booking: "-10% on your first booking",
      promo_online_payment: "online payment",

      // Features
      features_title: "Why choose",
      feature_electric: "100% Electric",
      feature_electric_desc: "Travel in a Tesla Model Y, the premium electric SUV. Zero emissions, total silence.",
      feature_drivers: "Professional Drivers",
      feature_drivers_desc: "Our drivers are trained to provide impeccable and discreet service.",
      feature_comfort: "Premium Comfort",
      feature_comfort_desc: "Onboard Wi-Fi, chargers, fresh water. Everything for your comfort.",
      feature_competitive: "Competitive rates",
      feature_competitive_desc: "Best VTC prices in Nice and French Riviera",
      feature_recent_vehicle: "Recent vehicle",
      feature_recent_vehicle_desc: "Immaculate Tesla Model Y",
      feature_water: "Water & chargers",
      feature_water_desc: "Premium comfort on board",
      feature_discretion: "Discretion",
      feature_discretion_desc: "Professional service",
      feature_multilingual: "Multilingual",
      feature_multilingual_desc: "FR, EN",
      feature_zero_emission: "100% Electric",
      feature_zero_emission_desc: "0 CO₂ emissions",

      // Loyalty
      loyalty_title: "Loyalty & Referral Program",
      loyalty_rewards: "Your trips reward you",
      loyalty_referral: "Referral",
      loyalty_referral_desc: "Refer a friend and both receive",
      loyalty_referral_amount: "€10 credit",
      loyalty_online_discount: "-10% online",
      loyalty_online_discount_desc: "Automatic online discount",
      loyalty_5_rides: "5 rides = -20%",
      loyalty_5_rides_desc: "Automatic 20% discount",
      loyalty_10th_free: "10th FREE",
      loyalty_10th_desc: "Free ride (max €25)",
      loyalty_gift: "Loyalty reward",
      loyalty_automatic: "Automatic",

      // Airport
      airport_title: "Nice Airport Transfer",
      airport_subtitle: "Nice Côte d'Azur Airport Shuttle",
      airport_fixed_rates: "Fixed rates",
      airport_one_way: "One way",
      airport_round_trip: "Round trip",
      airport_welcome_sign: "Welcome with name sign",
      airport_flight_tracking: "Real-time flight tracking",
      airport_free_wait: "30 min free waiting",
      airport_luggage: "Luggage included",
      airport_no_surprise: "No price surprises",
      airport_same_day: "Price valid for same-day round trip",
      airport_book: "Book",
      airport_st_tropez_note: "The round trip rate of 300€ to Saint-Tropez is valid only for a same-day round trip.",
      airport_privilege_note_label: "¹ Year-round fixed prices for privileged clients.",
      airport_privilege_note_text: "For other clients, these prices may vary by season and special events (Cannes Film Festival, Monaco Grand Prix, Christmas, New Year, etc.).",
      privilege_badge: "Privilege Program",
      privilege_subbadge: "Exclusive benefits",
      privilege_title: "Become a YOUMI GREEN VTC Privileged Client",
      privilege_body: "Registered clients who have completed a minimum of 10 rides over the last 6 months get access to low fixed prices for life, plus all exclusive benefits provided by YOUMI GREEN VTC.",
      privilege_eligibility: "Eligibility: 10 rides minimum over the past 6 months. Status granted automatically after verification.",
      privilege_cta: "Create an account",
      privilege_terms_link: "View conditions",
      price_guarantee_title: "Guaranteed fixed price — No pricing surprises",
      price_guarantee_text: "Your price is confirmed at booking and will never change, even in case of flight delay, traffic jams or weather conditions.",
      price_guarantee_full: "Your fare is confirmed at booking and will never change, even in case of flight delay, traffic or weather conditions. Unlike taxis and Uber, we never apply dynamic pricing.",
      fixed_price_badge: "Fixed price guaranteed \u2713",
      airport_seo: "VTC Nice airport - Transfer Nice Cannes - Nice Monaco airport shuttle - Private driver Saint-Tropez - Premium French Riviera VTC",

      // Why choose us
      why_title: "Why choose YOUMI GREEN VTC Nice?",
      why_subtitle: "Your private driver in Nice for premium, eco-friendly and professional rides.",

      // Business
      business_badge: "Business Clients",
      business_title: "Corporate VTC - Tailor-made solutions",
      business_desc: "Private driver service for businesses in Nice and the French Riviera. Monthly billing available for your business travel.",
      business_congress: "Conferences & Seminars",
      business_hotels: "Hotel Partnerships",
      business_trips: "Corporate Travel",
      business_billing: "Monthly billing",
      business_quote: "Request a corporate quote",
      business_advantages: "Business Advantages",
      business_adv_1: "Dedicated corporate account",
      business_adv_2: "Monthly grouped billing",
      business_adv_3: "Volume preferential rates",
      business_adv_4: "Detailed trip reporting",
      business_adv_5: "Dedicated driver available",
      business_adv_6: "Available 7 days a week",

      // Pricing
      pricing_title: "VTC Nice per-kilometer rates",
      pricing_subtitle: "Urban & regional rides • Standard sedan (4 passengers)",
      pricing_pickup: "Pick-up fee",
      pricing_day: "Day (7am-7pm)",
      pricing_night: "Night (7pm-7am)",
      pricing_per_km: "per km",
      pricing_wait: "Waiting",
      pricing_min_fare: "Minimum fare",
      pricing_min_booking: "Minimum booking",
      pricing_advance: "1h in advance",
      pricing_book: "Book VTC Nice",
      pricing_simulate: "Simulate",

      // Service area
      service_area_badge: "VTC Service Area",
      service_area_title: "Private driver French Riviera & Var",
      service_area_desc: "VTC Nice, private driver Cannes, VTC Monaco, Saint-Tropez transfer. We operate throughout the French Riviera and Var.",
      service_area_quote: "Request a quote",
      service_area_services: "Our VTC services",
      service_1: "Nice Côte d'Azur airport transfer",
      service_2: "Nice Cannes Monaco shuttle",
      service_3: "Saint-Tropez driver",
      service_4: "Events & weddings",
      service_5: "Hourly availability",
      service_6: "Long-distance VTC",

      // Reviews
      reviews_title: "Customer Reviews",
      reviews_subtitle: "Discover what our customers think about our service",
      reviews_what_say: "What our customers say about us",
      reviews_satisfaction: "Customer satisfaction is our priority. Discover their testimonials.",
      reviews_see_google: "See all our Google reviews",
      reviews_leave: "Leave us a review on Google",
      reviews_your_opinion: "Your opinion matters! Share your experience with YOUMI GREEN VTC",

      // Accessibility
      accessibility_badge: "Accessibility",
      accessibility_title: "Hearing impaired? Book in writing",
      accessibility_desc: "We offer a fully text-based booking service for hearing-impaired customers. No phone call required.",
      accessibility_book: "Book online (no call needed)",
      accessibility_whatsapp: "WhatsApp (text only)",

      // Footer
      footer_copyright: "Premium 100% electric private transport service.",
      footer_seo: "YOUMI GREEN VTC - Your premium and eco-friendly VTC service in Nice.",

      // Auth
      auth_welcome: "Welcome back!",
      auth_create: "Create an account",
      auth_login_subtitle: "Sign in to book your ride",
      auth_register_subtitle: "Register to enjoy our services",
      auth_firstname: "First name",
      auth_lastname: "Last name",
      auth_email: "Email",
      auth_phone: "Phone",
      auth_password: "Password",
      auth_confirm_password: "Confirm password",
      auth_login_btn: "Sign in",
      auth_register_btn: "Sign up",
      auth_no_account: "Don't have an account?",
      auth_has_account: "Already have an account?",
      auth_forgot_password: "Forgot password?",
      auth_forgot_title: "Forgot password",
      auth_forgot_desc: "Enter your email and we'll send you a link to reset your password.",
      auth_send_link: "Send link",
      auth_sending: "Sending...",
      auth_cancel: "Cancel",
      auth_min_chars: "Minimum 8 characters",
      auth_passwords_mismatch: "Passwords do not match",
      auth_loading: "Loading...",
      auth_verify_email: "Verify your email",
      auth_verify_email_sent: "A confirmation email has been sent to",
      auth_verify_email_click: "Click the link in the email to activate your account and sign in.",
      auth_verified_login: "I've verified, sign in",
      auth_resend: "Resend verification email",
      auth_referral_code: "Referral code (optional)",
      auth_referral_hint: "Enter a friend's code and both get €10 credit!",
      auth_business_account: "Business / Corporate Account",
      auth_company_name: "Company name *",
      auth_vat_number: "VAT number *",
      auth_billing_address: "Billing address",
      auth_billing_type: "Billing type",
      auth_per_trip: "Per trip",
      auth_monthly: "Monthly",
      auth_billing_note: "Invoices will be issued excl. VAT with 10% VAT applicable to transport.",
      back_home: "Back to home",

      // Booking
      booking_step_route: "Routes",
      booking_step_datetime: "Date & Time",
      booking_step_payment: "Payment",
      booking_your_trips: "Your trips",
      booking_add_trip: "Add a trip",
      booking_trip: "Trip",
      booking_remove: "Remove",
      booking_pickup: "Pick-up address",
      booking_destination: "Destination",
      booking_address_selected: "Address selected",
      booking_round_trip: "Same-day round trip (-10% on total)",
      booking_date_time: "Date and time for your trips",
      booking_min_advance: "Minimum booking 1 hour in advance",
      booking_date: "Date",
      booking_time: "Time",
      booking_select: "Select",
      booking_min_warning: "Booking must be made at least 1 hour in advance",
      booking_extra_info: "Additional information",
      booking_flight: "Flight number (optional)",
      booking_flight_hint: "For airport trips, we'll track your flight in real-time",
      booking_ambiance: "Preferred ambiance",
      booking_quiet: "Quiet",
      booking_music: "Music",
      booking_conversation: "Conversation",
      booking_climate: "Air conditioning / Heating",
      booking_climate_auto: "Auto",
      booking_climate_ac: "AC",
      booking_climate_heat: "Heating",
      booking_special: "Special requests (optional)",
      booking_special_placeholder: "Baby seat, bulky luggage, mobility assistance...",
      booking_payment_method: "Payment method",
      booking_card: "Credit card",
      booking_card_stripe: "Secure payment via Stripe",
      booking_apple_pay: "Apple Pay",
      booking_google_pay: "Google Pay",
      booking_paypal: "PayPal",
      booking_card_onboard: "Card on board",
      booking_pay_driver: "Pay the driver",
      booking_cash: "Cash",
      booking_fast_secure: "Fast and secure payment",
      booking_via_paypal: "Payment via your PayPal account",
      booking_promo_code: "Promo code",
      booking_promo_placeholder: "Enter your code",
      booking_apply: "Apply",
      booking_wallet: "My Wallet",
      booking_use: "Use",
      booking_wallet_deducted: "will be deducted from your trip",
      booking_back: "Back",
      booking_continue: "Continue",
      booking_confirm: "Confirm booking",
      booking_summary: "Summary",
      booking_round_trip_discount: "Round trip discount",
      booking_total_ht: "Total excl. VAT",
      booking_vat: "VAT (10%)",
      booking_wallet_used: "Wallet",
      booking_to_pay: "To pay",
      booking_paid_wallet: "Fully paid with your wallet!",
      booking_enter_addresses: "Enter addresses to see estimate",
      booking_co2: "0g CO₂ emitted • 100% electric",
      booking_hello: "Hello",
      booking_my_bookings: "My bookings",

      // Dashboard
      dashboard_hello: "Hello",
      dashboard_subtitle: "Manage your bookings and view your trip history.",
      dashboard_upcoming: "Upcoming trips",
      dashboard_past: "Past trips",
      dashboard_co2_saved: "CO₂ saved",
      dashboard_no_booking: "No bookings",
      dashboard_no_booking_desc: "You haven't made any bookings yet.",
      dashboard_first_booking: "Book my first trip",
      dashboard_upcoming_tab: "Upcoming",
      dashboard_past_tab: "History",
      new_booking: "New booking",

      // Confirmation
      confirm_checking: "Checking payment...",
      confirm_wait: "Please wait a moment",
      confirm_success: "Booking confirmed!",
      confirm_success_online: "Thank you for your booking. A confirmation email has been sent.",
      confirm_success_onboard: "Your driver will contact you to confirm the details.",
      confirm_cancelled: "Payment cancelled",
      confirm_cancelled_desc: "Your payment was cancelled. You can try again or choose another payment method.",
      confirm_retry: "New booking",
      confirm_view_bookings: "View my bookings",
      confirm_details: "Trip details",
      confirm_departure: "Departure",
      confirm_arrival: "Arrival",
      confirm_date: "Date",
      confirm_time: "Time",
      confirm_paid: "Paid",
      confirm_pay_driver: "Pay the driver",

      // Status
      status_confirmed: "Confirmed",
      status_pending: "Pending",
      status_cancelled: "Cancelled",

      // Evaluate
      eval_title: "How was your ride?",
      eval_subtitle: "Your feedback helps us improve",
      eval_rate: "Rate your experience",
      eval_5: "Excellent!",
      eval_4: "Very good!",
      eval_3: "Good",
      eval_2: "Could be better",
      eval_1: "Disappointing",
      eval_comment: "A comment? (optional)",
      eval_placeholder: "Share your experience...",
      eval_submit: "Submit my review",
      eval_already: "Already reviewed!",
      eval_already_desc: "You have already rated this ride",
      eval_thanks: "Thank you!",
      eval_thanks_desc: "Your review helps us improve our service",
      eval_happy: "Glad you enjoyed our service!",
      eval_google: "Also leave a Google review",
      eval_departure: "Departure",
      eval_arrival: "Arrival",
      eval_back: "Back to home",

      // Simulator
      simulator_title: "Price Simulator",
      simulator_subtitle: "Estimate the cost of your trip without creating an account",
      simulator_calculate: "Calculate price",

      // Contact
      contact_whatsapp: "Contact us on WhatsApp",

      // Quick Booking
      quick_badge: "Quick Booking",
      quick_title: "Book your ride",
      quick_subtitle: "No account needed. Fill in the form and we'll confirm by phone or WhatsApp.",
      quick_identity: "Your details",
      quick_optional: "optional",
      quick_route: "Your route",
      quick_options: "Options",
      quick_passengers: "Number of passengers",
      quick_message: "Message (optional)",
      quick_message_placeholder: "Baby seat, large luggage, flight number...",
      quick_submit: "Send my request",
      flight_number_title: "Flight information",
      flight_number_label: "Flight number",
      flight_number_hint: "We will track your flight to meet you on arrival.",
      round_trip_label: "Round trip",
      round_trip_same_day: "Same day round trip only",
      round_trip_price: "Round trip",
      one_way_price: "One way",
      estimate_loading: "Calculating price...",
      sim_title: "Price simulator",
      sim_subtitle: "Estimate the cost of your ride without creating an account",
      sim_pickup: "Pick-up address",
      sim_pickup_placeholder: "e.g. Nice Côte d'Azur Airport",
      sim_destination: "Destination",
      sim_dest_placeholder: "e.g. Cannes Centre",
      sim_address_selected: "Address selected",
      sim_calculating: "Calculating...",
      sim_calculate: "Calculate price",
      sim_electric: "electric",
      sim_price_ht: "Price excl. tax",
      sim_tva: "VAT (10%)",
      sim_total_ttc: "Total price incl. tax",
      sim_hour: "Pickup time",
      sim_night_warning: "Night surcharge +10% (9pm-6am)",
      sim_base_price: "Base fare",
      sim_calc_km: "Distance-based calculation",
      sim_calc_time: "Time-based calculation",
      sim_time_label: "time",
      sim_night_surcharge: "Night surcharge (+10%)",
      sim_rt_discount: "Round trip discount (-15% return)",
      sim_disclaimer_fixed: "* Fixed prices guaranteed for any ride between 6am and 9pm.",
      sim_seasonal_adj: "Fare adjustment",
      sim_disclaimer_night: "** A 10% surcharge applies automatically for any ride between 9pm and 6am.",
      sim_disclaimer_st_tropez: "*** Saint-Tropez round trip rate valid only for same-day round trip.",
      estimate_title: "Your ride estimate",
      estimate_duration: "Estimated duration",
      estimate_price_ttc: "Estimated price incl. tax",
      estimate_note: "* Indicative price. Final rate may vary depending on conditions.",
      stops_title: "Intermediate stops",
      stop_address: "Stop address",
      stop_placeholder: "Stop address...",
      stop_wait_time: "Waiting time",
      stop_no_wait: "None",
      stop_custom: "Other",
      stop_wait_cost: "Waiting cost",
      stop_add: "Add a stop",
      price_base_ride: "Base ride price",
      price_stops_wait: "Stops & waiting",
      quick_success_title: "Request sent!",
      quick_success_desc: "Your request has been sent! You will receive a confirmation shortly by WhatsApp or phone.",
      quick_create_account: "Create an account to manage my bookings",
      quick_or_login: "Already have an account?",

      // Common
      common_loading: "Loading...",

      // Video Showcase
      video_badge: "Discover our service",
      video_title_1: "The excellence of",
      video_title_2: "private transport",
      video_cta: "Book now",
      video_quote: "Request a quote",
      video_company: "Premium private driver - French Riviera",

      // Footer
      footer_legal: "Legal notice",
      footer_cgv: "Terms & Conditions",
      footer_privacy: "Privacy policy",
      footer_deletion: "Data deletion",
      footer_quote: "Request a quote",
      footer_admin: "Admin Area",
      footer_copyright: "Private driver French Riviera",
      footer_seo_line: "VTC Nice - Transfer Cannes - Monaco Shuttle - Saint-Tropez Driver",

      // Pin / Location
      pin_mode_active: "Pin active",
      pin_place: "Place a pin",
      pin_indicator: "Click on the map to place the pin",
      my_location: "My location",
      share_position_title: "Share your location with the driver",
      share_whatsapp: "WhatsApp",
      share_sms: "SMS",

      // Data Deletion Page
      deletion_title: "Data deletion",
      deletion_how: "How to request the deletion of your data",
      deletion_rgpd: "In accordance with the General Data Protection Regulation (GDPR), you may request the deletion of all your personal data held by",
      deletion_send_email: "To submit your request, send an email to:",
      deletion_subject: "Subject:",
      deletion_subject_value: "Data deletion",
      deletion_info_required: "Information to include in your email:",
      deletion_info_name: "Your full name",
      deletion_info_email: "Your email address associated with your account",
      deletion_info_phone: "Your phone number used for your bookings",
      deletion_info_other: "Any information to help identify you (booking number, etc.)",
      deletion_delay_title: "Processing time",
      deletion_delay_text: "Your request will be processed within a maximum of 30 business days from the receipt of your email. An acknowledgement of receipt will be sent by email with a tracking ID for your request.",
      deletion_data_title: "Data deleted",
      deletion_data_text: "The deletion covers all your personal data, including:",
      deletion_data_1: "Account information (name, email, phone)",
      deletion_data_2: "Booking and ride history",
      deletion_data_3: "Associated payment data",
      deletion_data_4: "Account preferences and settings",
      deletion_data_5: "Location data related to your rides",
      deletion_exceptions_title: "Legal exceptions",
      deletion_exceptions_text: "Certain data may be retained beyond your deletion request, in accordance with applicable legal obligations:",
      deletion_exc_1: "Invoices and accounting data",
      deletion_exc_1_detail: "mandatory retention for 10 years (French Commercial Code, art. L123-22)",
      deletion_exc_2: "Transaction data",
      deletion_exc_2_detail: "retention for 5 years for tax purposes",
      deletion_exc_3: "Data required for ongoing litigation",
      deletion_exc_3_detail: "retained until the resolution of the dispute",
      deletion_exc_4: "Regulatory obligations",
      deletion_exc_4_detail: "any data whose retention is required by French or European law",
      deletion_retained_note: "Data retained for legal obligation will only be used for that purpose and will be deleted upon expiry of the applicable legal period.",

      // Callback Page
      callback_title: "Deletion request received",
      callback_text: "Your data deletion request has been received. It will be processed within a maximum of",
      callback_days: "30 business days",
      callback_request_id: "Request ID",
      callback_id_info: "A request ID may be sent to your email for tracking purposes.",
      callback_contact_info: "For any questions about your request, contact us at:",
      callback_back: "Back to home",

      // Quote Request Page
      quote_title: "Request a",
      quote_title_accent: "quote",
      quote_subtitle: "Special event, group, long distance? Describe your needs and receive a personalized quote within 24h.",
      quote_contact_section: "Your details",
      quote_name: "Full name",
      quote_phone: "Phone",
      quote_email: "Email",
      quote_event_section: "Your event",
      quote_event_type: "Event type",
      quote_select: "Select...",
      quote_event_wedding: "Wedding",
      quote_event_seminar: "Seminar / Corporate",
      quote_event_party: "Party / Private event",
      quote_event_tourism: "Tourist circuit",
      quote_event_airport: "Airport transfer (group)",
      quote_event_long: "Long distance",
      quote_event_other: "Other",
      quote_date: "Preferred date",
      quote_time: "Time",
      quote_passengers: "Number of passengers",
      quote_duration: "Estimated duration",
      quote_duration_placeholder: "e.g. 3 hours, 1 day",
      quote_route_section: "Route",
      quote_pickup: "Departure location",
      quote_pickup_placeholder: "Pick-up address",
      quote_destination: "Destination",
      quote_dest_placeholder: "Destination address",
      quote_details_section: "Additional details",
      quote_details_placeholder: "Describe your specific needs: number of vehicles, luggage, multiple stops, special requirements...",
      quote_submit: "Send my quote request",
      quote_response_note: "Guaranteed response within 24h. You can also contact us directly at",
      quote_success_title: "Request sent!",
      quote_success_text: "We will get back to you shortly with your personalized quote.",

      // Reviews (hardcoded)
      review_1_name: "Marie L.",
      review_1_text: "Impeccable service! Punctual and very professional driver. The Tesla is a real plus for comfort. Highly recommended.",
      review_2_name: "Pierre D.",
      review_2_text: "Perfect Nice airport transfer. The driver was waiting with a sign, clean and air-conditioned car. Very fair price.",
      review_3_name: "Sophie M.",
      review_3_text: "Excellent service for my Nice-Monaco trip. Discreet driver and silent electric vehicle. Top!",
      review_cta_text: "Impeccable service! Punctual and very professional driver. The Tesla is a real plus for comfort and ecology. Highly recommended!",
      review_cta_text_2: "Excellent service for my airport transfer. Easy communication, clean and comfortable car. Perfect value for money.",

      // SEO footer text
      seo_text: "<strong>YOUMI GREEN VTC</strong> - Your premium eco-friendly <strong>VTC Nice</strong> service. <strong>Private driver Nice</strong> for all your travels: <strong>Nice Cannes transfer</strong>, <strong>Nice airport shuttle</strong>, <strong>VTC Monaco</strong>, <strong>Saint-Tropez chauffeur</strong>. Private transport service on the <strong>French Riviera</strong> and <strong>Var</strong> in a 100% electric Tesla Model Y. Book 1h in advance, competitive rates, multilingual service.",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
